import { formatDate } from "@angular/common";
import { Component, ElementRef, QueryList, ViewChildren } from "@angular/core";
import { AbstractControl, FormBuilder, FormGroup, FormArray, Validators, } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { PlacePickerComponent } from "src/app/place-picker/place-picker.component";
import { ApiService } from "src/app/shared/services/api.service";
import { ToastrMsgService } from "src/app/shared/services/shared-services/toastr.service";


@Component({
  selector: "app-add-project",
  templateUrl: "./add-project.component.html",
  styleUrls: ["./add-project.component.css"],
})
export class AddProjectComponent {
  projectId: any;
  rolesList: [] = [];
  userForm: FormGroup;
  locationForm: FormGroup;
  clientForm: FormGroup;
  availableStates: any[] = [];
  availableCities: any[] = [];
  userCForm: FormGroup;
  userGForm: FormGroup;
  form: FormGroup;

  docform: FormGroup = this.fb.group({
    documents: this.fb.array([this.createDocGroup()])
  });
  submitted = false;
  statusList = [
    { id: 1, status: "Pre-feasibility" },
    { id: 2, status: "Feasibility" },
    { id: 3, status: "Detailed Project Report (DPR)" },
    { id: 4, status: "Tendering" },
    { id: 5, status: "Construction" },
    { id: 6, status: "Maintenance" },
    { id: 7, status: "Handover" },
  ];
  statusList_ = [
    { id: "1", status: "Pre-Planning" },
    { id: "2", status: "Planning" },
    { id: "3", status: "Survey" },
    { id: "4", status: "Design Revisions & Scope Adjustments" },
    { id: "5", status: "Construction" },
    { id: "6", status: "Closure" },
  ];
  staffList: any[] = [];
  currentDate = new Date();
  selectedFile: string = '';
  searchKeyword = "";
  userData: any
  machineData: any
  cValue = formatDate(this.currentDate, "yyyy-MM-dd", "en-US");
  selectedFileName: string = '';
  acceptedFileTypes = '.pdf,.doc,.docx,.png,.jpg';
  @ViewChildren('fileInput') fileInputs!: QueryList<ElementRef<HTMLInputElement>>;
  allState: any
  allDistricts: any
  allSubDistricts: any
  allVillage: any;
  organizationId: any;
  userD: any;
  branchList: any;
  projectList: any;
  branchShow = true;
  selectedDomain = '';
  proShow=true
  domainOptions:any[] = [];
  // [
  //   'Residential', 'Commercial', 'Educational', 'Water',
  //   'Power', 'Gas', 'Telecom', 'Road', 'Consultancy'
  // ];
  domainFields: { [key: string]: any[] } = {
    Residential: [
      { key: 'housing_units', label: 'Housing Units', type: 'number', value: 100 },
      { key: 'community_amenities', label: 'Community Amenities', type: 'text', value: 'Park, Playground' },
      { key: 'zoning_requirements', label: 'Zoning Requirements', type: 'text', value: 'Residential Zone' }
    ],
    Commercial: [
      { key: 'retail_space', label: 'Retail Space', type: 'text', value: '50,000 sq ft' },
      { key: 'office_space', label: 'Office Space', type: 'text', value: '100,000 sq ft' },
      { key: 'parking_facilities', label: 'Parking Facilities', type: 'text', value: '500 spaces' }
    ],
    Educational: [
      { key: 'number_Of_classrooms', label: 'Number of Classrooms', type: 'number', value: 50 },
      { key: 'laboratory_facilities', label: 'Laboratory Facilities', type: 'text', value: 'Chemistry Lab, Physics Lab' },
      { key: 'sports_facilities', label: 'Sports Facilities', type: 'text', value: 'Football Field, Gymnasium' }
    ],
    Water: [
      { key: 'daily_capacity', label: 'Daily Capacity', type: 'text', value: '1,000,000 liters/day' },
      { key: 'treatment_type', label: 'Treatment Type', type: 'text', value: 'Reverse Osmosis' },
      { key: 'reservoir_size', label: 'Reservoir Size', type: 'text', value: '5 million liters' }
    ],
    Power: [
      { key: 'installed_capacity', label: 'Installed Capacity', type: 'text', value: '50 MW' },
      { key: 'grid_connection_type', label: 'Grid Connection Type', type: 'text', value: 'On-grid' },
      { key: 'backup_systems', label: 'Backup Systems', type: 'text', value: 'Diesel Generators' }
    ],
    Gas: [
      { key: 'pipeline_length', label: 'Pipeline Length', type: 'text', value: '25 km' },
      { key: 'storage_capacity', label: 'Storage Capacity', type: 'text', value: '500,000 liters' },
      { key: 'distribution_type', label: 'Distribution Type', type: 'text', value: 'Centralized' }
    ],
    Telecom: [
      { key: 'tower_height', label: 'Tower Height', type: 'text', value: '50 meters' },
      { key: 'coverage_area', label: 'Coverage Area', type: 'text', value: '10 sq km' },
      { key: 'fiberOptic_length', label: 'Fiber Optic Length', type: 'text', value: '100 km' }
    ],
    Road: [
      { key: 'road_length', label: 'Road Length', type: 'text', value: '15 km' },
      { key: 'lane_count', label: 'Lane Count', type: 'number', value: 4 },
      { key: 'pavement_type', label: 'Pavement Type', type: 'text', value: 'Asphalt' }
    ],
    Consultancy: [
      { key: 'advisory_scope', label: 'Advisory Scope', type: 'text', value: 'Feasibility & Design' },
      { key: 'consultant_count', label: 'Consultant Count', type: 'number', value: 5 },
      { key: 'engagement_duration', label: 'Engagement Duration', type: 'text', value: '6 months' }
    ]
  };
  constructor(
    private fb: FormBuilder,
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private toastrMsgService: ToastrMsgService,
    private router: Router, private route: ActivatedRoute, private dialog: MatDialog
  ) {
    this.userForm = this.fb.group({
      users: this.fb.array([this.createUserGroup()]),
    });
  }
  triggerFileInput(index: number): void {
    const inputsArray = this.fileInputs?.toArray();
    if (inputsArray && inputsArray[index]) {
      inputsArray[index].nativeElement.click();
    }
  }
  ngOnInit(): void {
    // const userData   =JSON.parse(localStorage.getItem("user") || '{}');
   const user = localStorage.getItem('user') as any;
    this.userD = JSON.parse(user);
    this.organizationId = this.userD.user.org_id; 
    // this.organizationId = this.userData.user.org_id;
    this.route.params.subscribe((params) => {
      this.projectId = params['id'];
    });
    this.domainOptions =  this.userD.user?.domain.split(",") || [];
    if (this.projectId) {
      this.proShow=false
      this.getProjectDetails();
    }
    this.fetchBranchList()
    this.fetchNewProject();
    this.form = this.formBuilder.group({
      company_name: [this.userD.user.org_name, Validators.required],
      company_id: [this.userD.user.org_id, Validators.required],
      company_code: [this.userD.user.company_code, Validators.required],
      project_name: ["", Validators.required],
      project_id: ["", ],
      branch_id: [''],
      start_date: ["", Validators.required],
      end_date: ["", Validators.required],
      status: ["", Validators.required],
      owner: [this.userD.user.org_name, Validators.required],
      budget_amount: ["", Validators.required],
      metadata: ["",],
      owner_id: ["",],
      domain: ["", Validators.required],
      scopeDefinition: ["", Validators.required],
      feasibilityAssessment: ["", Validators.required],
      conceptualDesign: ["", Validators.required],
      fundingSource: ["", Validators.required],
      stage: ['Preplanning']


    });
    this.locationForm = this.formBuilder.group({
      location: this.formBuilder.array([this.createLocationGroup()])
    });
    this.availableStates[0] = [];
    this.availableCities[0] = [];

    this.userCForm = this.formBuilder.group({
      contacts: this.formBuilder.array([this.createContactGroup()])
    });
    this.userGForm = this.formBuilder.group({
      materials: this.formBuilder.array([this.createMGroup()])
    });

    this.clientForm = this.formBuilder.group({
      client_name: ["", Validators.required],
      contact_person: ["", Validators.required],
      contact_number: ["", [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      khasra_no: ["", Validators.required],
      area: ["", Validators.required],
      state: ["", Validators.required],
      district: ["", Validators.required],
      sub_district: ["", Validators.required],
      villages: ["", Validators.required],
      client_id: [""],

    });

    this.fetchData();
    this.fetchDataM();
    this.getstates()
  }
  onDomainChange(domain: string) {
    this.selectedDomain = domain;
    Object.keys(this.form.controls).forEach(key => {
      if (key !== 'domain' && this.domainFields[domain]?.find(field => field.key === key) === undefined &&
        Object.values(this.domainFields).flat().some(field => field.key === key)) {
        this.form.removeControl(key);
      }
    });

    this.domainFields[domain].forEach(field => {
      this.form.addControl(field.key, this.fb.control(field.value));
    });
  }
  fetchNewProject() {
    const params = { keyword: this.searchKeyword ? this.searchKeyword : "" };
    this.apiService.getProjectCommonAll().subscribe({
      next: (res: any) => {
        console.log(res);

        // this.dataSource.data = res.data;
        this.projectList = res.data
        this.fetchBranchList();
      },
      error: (err) => {
        console.log(err);
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => console.log('Observable complete'),
    });
  }

  fetchBranchList() {
    this.apiService.getOrganizationsBranch(this.organizationId).subscribe({
      next: (res: any) => {
        if (res.data.length != 0) {
          this.branchList = res.data
        } else {
          this.branchShow = false
        }

      },
      error: (err) => {
        this.toastrMsgService.error(err.error.message);
      },
      complete: () => '',
    });
  }
  onProjectChange(selectedBranchId: any) {
    console.log(selectedBranchId);
    this.apiService.getProjectCommonId(selectedBranchId).subscribe({
      next: (res: any) => {
        console.log(res)

        this.form.patchValue({
          project_name: res.project_name,
          project_id: res.id,
          company_name: this.userD.user.org_name,
          company_id: this.userD.user.org_id,
          company_code: this.userD.user.company_code,
          branch_name: res.branch_name,
          branch_id: +res.branch_id,
          domain: res.domain,
          infrastructure_type: res.infrastructure_type,
          size: res.size,
          client_name: res.client_name,
          start_date: res.start_date,
          end_date: res.end_date,
          budget_amount: res.budget_amount,
          fundingSource: res.fundingsource,
          scopeDefinition: res.scopedefinition,
          timeline_start: res.timeline_start,
          timeline_end: res.timeline_end,
          permit_status: res.permit_status,
        });
        this.onDomainChange(this.form.value.domain)
        this.domainFields[this.form.value.domain].forEach(field => {
          if (res.hasOwnProperty(field.key)) {
            this.form.get(field.key)?.patchValue(res[field.key]);
          }
        });

        this.fetchBranchList();

        const lData = res?.location || [];
        const branchFormArray = this.location;
        branchFormArray.clear();


        lData.forEach((loc: {
          address_line_2: string;
          address_line_1: string; country: any; state: any; city: any; lat: any; long: any; pincode: any; officename: any;
        }, index: number) => {
          const branchGroup = this.createLocationGroup();
          this.location.push(branchGroup);

          branchGroup.patchValue({ country: loc.country || '' });
          this.onCountryBChange(index);

          setTimeout(() => {
            branchGroup.patchValue({ state: loc.state || '' });
            this.onStateBChange(index);


            branchGroup.patchValue({
              city: loc.city || '',
              lat: loc.lat || '',
              long: loc.long || '',
              pincode: loc.pincode || '',
              officename: loc.officename || '',
              address_line_1: loc.address_line_1 || '',
              address_line_2: loc.address_line_2 || '',
            });
          }, 200);
        });


        if (branchFormArray.length === 0) {
          branchFormArray.push(this.createLocationGroup());
        }



        const client = res
        this.clientForm.patchValue({
          client_name: client.client_name,
          contact_person: client.contact_person,
          contact_number: client.contact_number,
          state: client.state,
          district: client.district,
          sub_district: client.sub_district,
          villages: client.villages,
          khasra_no: client.khasra_no,
          area: client.area,
          client_id:client.client_id

        });
        this.getdistricts()
        this.getsubdistricts()
        this.getvillages()



      },
      error: (err) => {

        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });

  }

  onBranchChange(selectedBranchId: any) {
    const selectedBranch = this.branchList.find((b: { branch_id: any; }) => b.branch_id === selectedBranchId);
    const manager = selectedBranch?.primary_contact_name || '';
    this.form.get('owner')?.setValue(manager);
  }

  get contacts() {
    return this.userCForm.get('contacts') as FormArray;
  }



  createContactGroup(): FormGroup {
    return this.formBuilder.group({
      name: ['', Validators.required],
      start_date: ['', Validators.required],
      end_date: ['', Validators.required],
    });
  }

  addContact() {
    this.contacts.push(this.createContactGroup());
  }

  removeContact(index: number) {
    if (this.contacts.length > 1) {
      this.contacts.removeAt(index);
    }
  }

  get materials() {
    return this.userGForm.get('materials') as FormArray;
  }



  createMGroup(): FormGroup {
    return this.formBuilder.group({
      name: ['', Validators.required],
      start_date: ['', Validators.required],
      end_date: ['', Validators.required],
    });
  }

  addM() {
    this.materials.push(this.createMGroup());
  }

  removeM(index: number) {
    if (this.materials.length > 1) {
      this.materials.removeAt(index);
    }
  }
  get users(): FormArray {
    return this.userForm.get("users") as FormArray;
  }

  createUserGroup(): FormGroup {
    return this.fb.group({
      name: ["", Validators.required],
      role: ["", Validators.required],
    });
  }

  addUser(): void {
    this.users.push(this.createUserGroup());
  }

  removeUser(index: number): void {
    if (this.users.length > 1) {
      this.users.removeAt(index);
    }
  }
  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }
  get f1(): { [key: string]: AbstractControl } {
    return this.docform.controls;
  }

  get location() {
    return this.locationForm.get('location') as FormArray;
  }



  createLocationGroup(): FormGroup {
    return this.formBuilder.group({
      lat: ['', Validators.required],
      long: ['', Validators.required,],
      city: ['', Validators.required,],
      state: ['', Validators.required],
      country: ['', Validators.required],
      pincode: ['', Validators.required],
      address_line_1: ["", Validators.required],
      address_line_2: ["", Validators.required],
    });
  }

  addBranch() {
    this.location.push(this.createLocationGroup());
    const index = this.location.length - 1;
    this.availableStates[index] = [];
    this.availableCities[index] = [];
  }

  removeBranch(index: number) {
    if (this.location.length > 1) {
      this.location.removeAt(index);
    }
    this.availableStates.splice(index, 1);
    this.availableCities.splice(index, 1);
  }

  createDocGroup(): FormGroup {
    return this.fb.group({
      doc_name: ['', Validators.required],
      file: ['', Validators.required],
      file_name: ['']
    });
  }

  get documents(): FormArray {
    return this.docform.get('documents') as FormArray;
  }

api(){
  console.log(this.form.value)
}
  onReset(): void {
    this.submitted = false;
    this.form.reset();
  }

  fetchDataM() {
    const params = { keyword: this.searchKeyword ? this.searchKeyword : "" };
    this.apiService.getMachine(params).subscribe({
      next: (res: any) => {
        this.machineData = res;
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });
  }

  fetchDataUser() {
    const params = { keyword: this.searchKeyword ? this.searchKeyword : "" };
    this.apiService.getUsers(params).subscribe({
      next: (res: any) => {
        this.userData = res
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.message);
      },
      complete: () => '',
    });
  }

  fetchData() {
    const params = { keyword: "" };
    this.apiService.getStaff(params).subscribe({
      next: (res: any) => {
        this.staffList = res.data;
      },
      error: (err) => {

        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });
  }

  getProjectDetails() {
    this.apiService.getProjectId(this.projectId).subscribe({
      next: (res: any) => {
        this.form.patchValue({
          project_name: res.project_name ?? '',
          project_id: res.project_id ?? '',
          branch_id: res.branch_id ?? '',
          start_date: res.start_date ? new Date(res.start_date) : '',
          end_date: res.end_date ? new Date(res.end_date) : '',
          status: res.status ?? '',
          owner: res.owner ?? '',
          budget_amount: res.budget_amount ?? '',
          metadata: res.metadata ?? '',
          owner_id: res.owner_id ?? '',
          domain: res.domain ?? '',
          scopeDefinition: res.scopedefinition ?? '',
          feasibilityAssessment: res.feasibilityassessment ?? '',
          conceptualDesign: res.conceptualdesign ?? '',
          fundingSource: res.fundingsource ?? '',

          // Residential
          housingUnits: res.housingunits ?? '',
          communityAmenities: res.communityamenities ?? '',
          zoningRequirements: res.zoningrequirements ?? '',

          // Commercial
          retailSpace: res.retailspace ?? '',
          officeSpace: res.officespace ?? '',
          parkingFacilities: res.parkingfacilities ?? '',

          // Educational
          numberOfClassrooms: res.numberofclassrooms ?? '',
          laboratoryFacilities: res.laboratoryfacilities ?? '',
          sportsFacilities: res.sportsfacilities ?? '',

          // Water
          dailyCapacity: res.dailycapacity ?? '',
          treatmentType: res.treatmenttype ?? '',
          reservoirSize: res.reservoirsize ?? '',

          // Power
          installedCapacity: res.installedcapacity ?? '',
          gridConnectionType: res.gridconnectiontype ?? '',
          backupSystems: res.backupsystems ?? '',

          // Gas
          pipelineLength: res.pipelinelength ?? '',
          storageCapacity: res.storagecapacity ?? '',
          distributionType: res.distributiontype ?? '',

          // Telecom
          towerHeight: res.towerheight ?? '',
          coverageArea: res.coveragearea ?? '',
          fiberOpticLength: res.fiberopticlength ?? '',

          // Road
          roadLength: res.roadlength ?? '',
          laneCount: res.lanecount ?? '',
          pavementType: res.pavementtype ?? '',

          // Consultancy
          advisoryScope: res.advisoryscope ?? '',
          consultantCount: res.consultantcount ?? '',
          engagementDuration: res.engagementduration ?? '',
        });
        this.onDomainChange(this.form.value.domain)
   this.domainFields[this.form.value.domain].forEach(field => {
          if (res.hasOwnProperty(field.key)) {
            this.form.get(field.key)?.patchValue(res[field.key]);
          }
        });



        const lData = res?.location || [];
        const branchFormArray = this.location;
        branchFormArray.clear();


        lData.forEach((loc: {
          address_line_2: string;
          address_line_1: string; country: any; state: any; city: any; lat: any; long: any; pincode: any; officename: any;
        }, index: number) => {
          const branchGroup = this.createLocationGroup();
          this.location.push(branchGroup);

          // Step 1: Patch country and trigger state dropdown
          branchGroup.patchValue({ country: loc.country || '' });
          this.onCountryBChange(index); // load states for this country

          // Step 2: Wait a bit to ensure states are loaded, then patch state and trigger cities
          setTimeout(() => {
            branchGroup.patchValue({ state: loc.state || '' });
            this.onStateBChange(index); // load cities for this state

            // Step 3: Patch remaining fields
            branchGroup.patchValue({
              city: loc.city || '',
              lat: loc.lat || '',
              long: loc.long || '',
              pincode: loc.pincode || '',
              officename: loc.officename || '',
              address_line_1: loc.address_line_1 || '',
              address_line_2: loc.address_line_2 || '',
            });
          }, 200); // delay to allow API call for states to finish
        });

        // If empty:
        if (branchFormArray.length === 0) {
          branchFormArray.push(this.createLocationGroup());
        }



        const client = res
        this.clientForm.patchValue({
          client_name: client.client_name,
          contact_person: client.contact_person,
          contact_number: client.contact_number,
          state: client.state,
          district: client.district,
          sub_district: client.sub_district,
          villages: client.villages,
          khasra_no: client.khasra_no,
          area: client.area,

        });
        this.getdistricts()
        this.getsubdistricts()
        this.getvillages()



      },
      error: (err) => {

        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });
  }

  onSubmit(): void {
    if (this.projectId) {
      this.update();
    }
    else {
      if (this.form.valid) {
      } else {
        this.form.markAllAsTouched();
      }
      const formData = {
        ...this.form.value,
        ...this.locationForm.value,
        ...this.clientForm.value

      };


      this.apiService.saveProject(formData).subscribe({
        next: (res) => {
          this.toastrMsgService.success("Project saved successfully");
          this.router.navigate(["/home/pre-planning-projects"]);
        },
        error: (err) => {
          this.toastrMsgService.error(err.error.errorMessage);
        },
        complete: () => '',
      });
    }
  }



  addDoc() {
    this.documents.push(this.createDocGroup());
  }

  removeDoc(index: number) {
    this.documents.removeAt(index);
  }

  onFileSelected(event: any, index: number): void {
    const file = event.target.files[0];
    if (file) {
      const docGroup = this.documents.at(index);
      docGroup.get('file')?.setValue(file);
      docGroup.get('file_name')?.setValue(file.name); // set the name to show in input
    }
  }


  update() {

    const formData = {
      ...this.form.value,
      ...this.locationForm.value,
      ...this.clientForm.value

    };
    this.apiService.updateProject(this.projectId, formData).subscribe({
      next: (res) => {
        this.toastrMsgService.success("Project updated successfully");
        this.router.navigate(["/home/pre-planning-projects"]);
      },
      error: (err) => {

        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });
  }


  onCountryBChange(index: number) {
    const branch = this.location.at(index);
    const selectedCountry = branch.get('country')?.value;
    this.apiService.getstates().subscribe({
      next: (res) => {
        this.availableStates[index] = res ? res : []
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });


    // Reset dependent controls
    branch.patchValue({ state: '', city: '' });
  }

  onStateBChange(index: number) {
    const branch = this.location.at(index);
    const selectedCountry = branch.get('country')?.value;
    const selectedState = branch.get('state')?.value;
    this.apiService.getdistricts(selectedState).subscribe({
      next: (res) => {
        this.availableCities[index] = res ? res : [];
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });



    // Reset city control
    branch.patchValue({ city: '' });
  }


  getstates() {
    this.apiService.getstates().subscribe({
      next: (res) => {
        this.allState = res
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });
  }

  getdistricts() {
    const state = this.clientForm.value.state;

    this.apiService.getdistricts(state).subscribe({
      next: (res) => {
        this.allDistricts = res
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });
  }
  getsubdistricts() {
    const state = this.clientForm.value.state;
    const district = this.clientForm.value.district;
    this.apiService.getSubdistricts(state, district).subscribe({
      next: (res) => {
        this.allSubDistricts = res
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });
  }
  getvillages() {
    const state = this.clientForm.value.state;
    const district = this.clientForm.value.district;
    const sub_district = this.clientForm.value.sub_district;
    this.apiService.getvillages(state, district, sub_district).subscribe({
      next: (res) => {
        this.allVillage = res
      },
      error: (err) => {
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => '',
    });
  }


  openPicker(index: number, branch: any) {
    const dialogRef = this.dialog.open(PlacePickerComponent, {
      width: '600px',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        branch.patchValue({
          lat: result.lat,
          long: result.lng
        });
      }
    });
  }

}
